import styled from 'styled-components';

import BamOnlineLink from 'components/b2c/BamOnlineLink';
import {
  getSpacing,
  fontSize,
  letterSpacing,
  fontWeight,
  lineHeight,
  colorUsage,
} from 'stylesheetB2c';

const MODAL_ROW_MARGIN = getSpacing(5);

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
ModalContainer.displayName = 'ModalContainer';

export const Logo = styled.img`
  height: ${getSpacing(8)};
  margin-bottom: ${MODAL_ROW_MARGIN};
`;
Logo.displayName = 'Logo';

export const StyledMessage = styled.p`
  color: ${colorUsage.blackText};
  font-size: ${fontSize.small};
  letter-spacing: ${letterSpacing.medium};
  font-weight: ${fontWeight.normal};
  line-height: ${lineHeight.XSmall};
  text-align: center;

  :last-of-type {
    margin-bottom: ${MODAL_ROW_MARGIN};
  }
`;
StyledMessage.displayName = 'StyledMessage';

export const StyledLink = styled(BamOnlineLink)`
  width: ${getSpacing(34)};
  height: ${getSpacing(6)};
`;
StyledLink.displayName = 'StyledLink';
